import api from './api';

const BASE_URL = '/patient-token';

export const PatientTokenService = {
  // ── Admin: Generate a patient link ────────────────────────────────────
  async generateToken(patientId, visitId, bookingId) {
    return (await api.post(`${BASE_URL}/generate`, { patientId, visitId, bookingId })).data;
  },

  // ── Public: Validate token ────────────────────────────────────────────
  async validateToken(token) {
    return (await api.get(`${BASE_URL}/validate/${token}`)).data;
  },

  // ── Public: Get current patient data for deferred fields ──────────────
  async getFormData(token) {
    return (await api.get(`${BASE_URL}/form/${token}`)).data;
  },

  // ── Public: Submit deferred patient data ──────────────────────────────
  async submitForm(token, data) {
    return (await api.post(`${BASE_URL}/form/${token}`, data)).data;
  },
};

export default PatientTokenService;
